import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api';
import Register from './Register';

export default function Login() {
  const { login, loginWithGoogle } = useAuth();
  const [showRegister, setShowRegister] = useState(false);
  const [form, setForm]   = useState({ username:'', password:'' });
  const [err,  setErr]    = useState('');
  const [busy, setBusy]   = useState(false);
  const [sso,  setSso]    = useState(null);     // {enabled, client_id}
  const gbtn = useRef(null);

  // Load SSO config + render the Google button if enabled
  useEffect(() => { api.get('/auth/sso-config').then(r => setSso(r.data)).catch(() => setSso({ enabled:false })); }, []);
  useEffect(() => {
    if (!sso?.enabled || !sso.client_id || showRegister) return;
    const onCred = async (resp) => {
      setBusy(true); setErr('');
      try { await loginWithGoogle(resp.credential); }
      catch (ex) { setErr(ex.response?.data?.error || 'Google sign-in failed'); }
      finally { setBusy(false); }
    };
    const render = () => {
      if (!window.google || !gbtn.current) return;
      window.google.accounts.id.initialize({ client_id: sso.client_id, callback: onCred, auto_select: false });
      window.google.accounts.id.renderButton(gbtn.current, { theme:'outline', size:'large', width:330, text:'signin_with' });
      window.google.accounts.id.prompt();   // auto-show the Google account chooser (One Tap)
    };
    if (window.google) { render(); return; }
    const s = document.createElement('script');
    s.src = 'https://accounts.google.com/gsi/client'; s.async = true; s.defer = true; s.onload = render;
    document.body.appendChild(s);
  }, [sso, showRegister, loginWithGoogle]);

  // All hooks declared above this line (Rules of Hooks)
  if (showRegister) return <Register onBack={() => setShowRegister(false)} />;

  const submit = async e => {
    e.preventDefault();
    if (!form.username || !form.password) { setErr('Enter username and password'); return; }
    setBusy(true); setErr('');
    try {
      await login(form.username, form.password);
    } catch (ex) {
      setErr(ex.response?.data?.error || 'Login failed');
    } finally { setBusy(false); }
  };

  return (
    <div style={{
      minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
      background:'var(--bg)',
      backgroundImage:'radial-gradient(ellipse at 20% 50%, rgba(79,142,247,0.08) 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, rgba(167,139,250,0.06) 0%, transparent 60%)'
    }}>
      <div style={{ width:'100%', maxWidth:380, padding:24 }}>
        {/* Header */}
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <img src={`${process.env.PUBLIC_URL || ''}/it-logo.png`} alt="IT"
            style={{ height:64, width:'auto', margin:'0 auto 16px', display:'block', objectFit:'contain' }} />
          <h1 style={{ fontSize:22, fontWeight:600, marginBottom:6 }}>IT Support Portal</h1>
          <p style={{ fontSize:13, color:'var(--text2)' }}>Sign in to your account</p>
        </div>

        {/* Form */}
        <div className="card" style={{ padding:24 }}>
          <form onSubmit={submit}>
            <div className="form-group">
              <label>Username</label>
              <input type="text" value={form.username} autoFocus
                onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
                placeholder="Enter your username" />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input type="password" value={form.password}
                onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                placeholder="Enter your password" />
            </div>
            {err && <div className="err-msg">{err}</div>}
            <button type="submit" className="btn btn-primary" disabled={busy}
              style={{ width:'100%', justifyContent:'center', marginTop:16, padding:'10px' }}>
              {busy ? 'Signing in…' : 'Sign In'}
            </button>
          </form>

          {sso?.enabled && (
            <>
              <div style={{ display:'flex', alignItems:'center', gap:10, margin:'18px 0 12px', color:'var(--text3)', fontSize:12 }}>
                <div style={{ flex:1, height:1, background:'var(--border)' }} /> or <div style={{ flex:1, height:1, background:'var(--border)' }} />
              </div>
              <div ref={gbtn} style={{ display:'flex', justifyContent:'center' }} />
            </>
          )}
        </div>

        <p style={{ textAlign:'center', fontSize:13, color:'var(--text2)', marginTop:16 }}>
          Staff member?{' '}
          <span onClick={() => setShowRegister(true)} style={{ color:'var(--accent)', cursor:'pointer', fontWeight:500 }}>
            Register to raise tickets
          </span>
        </p>
        <p style={{ textAlign:'center', fontSize:12, color:'var(--text3)', marginTop:8 }}>
          Contact admin if you forgot your password
        </p>
      </div>
    </div>
  );
}
